import React from 'react';
import { Divider, Grid, Icon, Tooltip, Typography } from '@mui/material';

interface ITextFieldReadOnlyProps {
    id: string;
    label: string;
    value: any;
    hasDivider?: boolean;
    hasToolTip?: boolean;
    iconName?: string;
    noWrap?: boolean;
    align?: 'right' | 'left' | 'inherit' | 'center' | 'justify';
    variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline';
    colorValue?: string;
}

export const TextFieldReadOnly: React.FC<ITextFieldReadOnlyProps> = ({ id, label, value, hasDivider = true, hasToolTip = false, iconName, noWrap, align = 'justify', variant = 'subtitle2', colorValue }) => {
    if (value === undefined) value = '';

    const isReactComponent = React.isValidElement(value);
    const textNoWrap = noWrap ?? false;
    const textSx = textNoWrap ? { overflow: 'hidden', textOverflow: 'ellipsis' } : undefined;

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} mb={-.5}>
                <Typography sx={{ fontSize: 12 }} color="text.secondary" gutterBottom>
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={12} md={12} mb={-.5}>
                {isReactComponent ? (
                    // Renderiza valor diretamente se for um componente React
                    value
                ) : (
                    // Caso contrário, renderiza como texto/HTML com ou sem tooltip
                    noWrap ? (
                        hasToolTip && value !== null ? (
                            <Tooltip title={value} placement={'bottom-start'}>
                                <Typography 
                                    id={id} 
                                    variant={variant} 
                                    component="div" 
                                    noWrap={textNoWrap}
                                    sx={textSx}
                                >
                                    {iconName && (
                                        <Icon fontSize='small'>{iconName}</Icon>
                                    )} 
                                    <span style={{ color: colorValue }} dangerouslySetInnerHTML={{ __html: value }} />
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Typography 
                                variant={variant} 
                                component="div" 
                                noWrap={textNoWrap}
                                whiteSpace={textNoWrap ? undefined : 'normal'}
                                sx={textSx}
                                align={align}
                            >
                                {iconName && (
                                    <Icon fontSize='small'>{iconName}</Icon>
                                )} 
                                <span style={{ color: colorValue }} dangerouslySetInnerHTML={{ __html: value }} />
                            </Typography>
                        )
                    ) : (
                        hasToolTip && value !== null ? (
                            <Tooltip title={value} placement={'bottom-start'}>
                                <Typography 
                                    id={id} 
                                    variant={variant} 
                                    component="div" 
                                    noWrap={textNoWrap}
                                    sx={textSx}
                                >
                                    {iconName && (
                                        <Icon fontSize='small'>{iconName}</Icon>
                                    )} 
                                    <span style={{ color: colorValue }} dangerouslySetInnerHTML={{ __html: value }} />
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Typography 
                                variant={variant} 
                                component="div" 
                                noWrap={textNoWrap}
                                whiteSpace={textNoWrap ? undefined : 'normal'}
                                sx={textSx}
                                align={align}
                            >
                                {iconName && (
                                    <Icon fontSize='small'>{iconName}</Icon>
                                )} 
                                <span style={{ color: colorValue }} dangerouslySetInnerHTML={{ __html: value }} />
                            </Typography>
                        )
                    )
                )}
            </Grid>
            {hasDivider && (
                <Grid item mb={0} mr={0}>
                    <Divider 
                        variant='fullWidth' 
                        sx={{
                            mt: 1,
                            borderColor: 'GrayText'
                        }} 
                    />
                </Grid>
            )}
        </React.Fragment>
    );
};
